import React, {
  Component, createRef
} from "react";
import IconButton from "@material-ui/core/IconButton";
import ToolTip from "@material-ui/core/Tooltip";
// import SaveIcon from "@material-ui/icons/Save";
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import qs from "query-string";
import MaterialTable from "zh-material-table";
import { withCurl } from "zh-common-modules";
import { SearchForm } from "views/shareViews";
import {
  schema,
  columns,
} from "./schema";
import {
  AUTHORIZE_LIST_GET,
  AUTHORIZE_DELETE_POST
} from "config/url";
import CustomDialog from "./Dialog";
import AddDialog from "./AddDialog";
import Alert from "views/shareViews/Alert";

class AuthenticationList extends Component {
  constructor(props){
    super(props);
    this.tableRef = createRef();
    const params = qs.parse(props.location.search);
    this.params = params || {};
    const paramKeys = Object.keys(this.params);
    const newSchema = schema.map(value => {
      if(paramKeys.indexOf(value.name) > -1){
        value.value = this.params[value.name];
      } else {
        value.type === "time" ? value.value = null : value.value = "";
      }
      return value;
    })
    this.searchSchema = newSchema;
    this.state = {
      open : false,
      fileId : "",
      addOpen : false
    }
  }

  setOpen = (status) => {
    this.setState({
      open : status
    })
  }

  refreshData = (query) => new Promise((res, rej) => {
    const { page, pageSize } = query;
    const { params } = this;
    this.props.curl.get(AUTHORIZE_LIST_GET, {
      ...params,
      ...{ offset : page * pageSize, limit : pageSize}
    }).then (response => {
      const {
        count, rows
      } = response;
      res({
        data : rows,
        page : page,
        totalCount : ~~count
      })
    })
  })

  handleView = (rowData) => {
    const { code } = rowData;
    this.setState({
      open : true,
      fileId : code
    })
  }

  handleSearch = (params) => {
    this.params = params;
    const newParams = qs.stringify(params);
    this.props.history.push(`/authentication-list?${newParams}`)
    const { tableRef } = this;
    tableRef.current && tableRef.current.onQueryChange()
  }

  refresh = () => {
    const { tableRef } = this;
    tableRef.current && tableRef.current.onQueryChange()
  }

  closeView = () => {
    this.setState({
      open : false
    })
  }

  handleDelete = (rowData) => {
    Alert({
      handleSubmit : () => {
        const { id } = rowData;
        this.props.curl.post(AUTHORIZE_DELETE_POST, {
          id
        }).then(res => {
          this.refresh();
        })
      }
    })

  }

  actionRender = (rowData) => {
    return (
      <>
        <ToolTip title="查看">
          <IconButton onClick={() => {this.handleView(rowData)}}>
            <VisibilityIcon/>
          </IconButton>
        </ToolTip>
        <ToolTip title="删除">
          <IconButton onClick={() => {this.handleDelete(rowData)}}>
            <DeleteIcon style={{color : "red"}}/>
          </IconButton>
        </ToolTip>
      </>
    )
  }

  handleAdd = () => {
    this.setState({
      addOpen : true
    })
  }

  toggleAdd = status => {
    this.setState({
      addOpen : status
    })
  }

  render(){
    const {
      open,
      fileId
    } = this.state;

    const {
      addOpen
    } = this.state;

    return (
      <div style={{padding : "10px"}}>
        <SearchForm 
          formSchema  = { this.searchSchema }
          formTitle   = "搜索条件"
          onSearch    = { this.handleSearch }
        />
        <MaterialTable
          title   = "授权列表"
          columns = { columns(this.actionRender) }
          data    = { this.refreshData }
          tableRef= { this.tableRef }
          options = {{
            padding : "dense"
          }}
          actions={[
            {
              icon: AddIcon,
              tooltip: '添加授权函',
              isFreeAction: true,
              onClick: this.handleAdd
            }
          ]}
        />
        <CustomDialog
          open = {open}
          setOpen = {this.setOpen}
          fileId = {fileId}
        />
        <AddDialog
          open = {addOpen}
          setOpen = {this.toggleAdd}
          refresh = {this.refresh}
        />
      </div>
    )
  }
}

export default withCurl(false, false)(AuthenticationList);